import React from "react";
import useQueryURL from "../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import VerifyPaymentForm from "../../../features/wallet/components/wallets/VerifyPaymentForm/VerifyPaymentForm";

export const VERIFY_PAYMENT_MODAL_ID = "verify-payment-modal";

export default function VerifyPaymentPage({ onSuccess }: { onSuccess?: () => void }) {
  return (
    <div>
      <VerifyPaymentForm onSuccess={onSuccess} />
    </div>
  );
}

export const VerifyPaymentDrawer = ({
  modalId,
}: {
  modalId?: string;
}) => {
  const modalIdFound = modalId || VERIFY_PAYMENT_MODAL_ID;
  const { removeQueryValue } = useQueryURL();

  const onClose = () => {
    removeQueryValue([modalIdFound]);
  };

  const onSuccess = () => {
    onClose();
  };

  return (
    <ModalDrawer
      urlParamName={modalIdFound}
      title="Vérifier paiement Kkiapay"
      onClose={onClose}
    >
      <VerifyPaymentPage onSuccess={onSuccess} />
    </ModalDrawer>
  );
};
